import { graphql } from 'gql';

export const createBimOrderQueriesGql = graphql(`
    mutation bimCreateWorkOrder($contractId: Long!) {
        bimCreateWorkOrder(contractId: $contractId) {
            data {
                id
                isWorkOrderChangeRequired
                status
            }
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);
